<script lang="ts">
	import type { ClassValue } from 'svelte/elements';
	import type { RelAttribute, Target } from '../link/types';
	import { type Snippet } from 'svelte';

	let obfuscatedHref: string | undefined = $state(undefined);

	interface Props {
		href?: string;
		target?: Target;
		rel?: RelAttribute;
		dataTestId?: string;
		class?: ClassValue;
		children?: Snippet;
		onclick?: (e: MouseEvent) => void;
		tag?: string;
	}

	const {
		href,
		target,
		rel,
		dataTestId,
		class: classes,
		children,
		onclick,
		tag = 'span',
	}: Props = $props();

	function handleClick(e: MouseEvent | KeyboardEvent) {
		if (!href) {
			return;
		}

		const currentTarget = e?.currentTarget as HTMLButtonElement;
		const obfuscatedLink = currentTarget?.dataset?.o;

		onclick?.(new MouseEvent('click'));

		if (obfuscatedLink) {
			window.open(window.atob(obfuscatedLink), target, rel);
		}
	}

	obfuscatedHref = (href && globalThis?.btoa(href)) || undefined;
</script>

<svelte:element
	this={tag}
	role="link"
	tabindex="0"
	data-testid={dataTestId}
	data-o={obfuscatedHref}
	class={['obfuscated inline-block', classes]}
	onclick={handleClick}
	onkeydown={() => {}}
>
	{@render children?.()}
</svelte:element>
